import React, { useCallback, useEffect, useRef, } from "react";
import { useCombobox, } from "downshift";
import { ArrowDown2 } from "@bale/icons";
import { BaseTextFieldFrame, BaseTextFieldset, } from "../inputs/TextField/BaseTextFieldFrame";
import { getColorByName } from "../../utils/color";
import { DarkNeutralsColorNames } from "../../theme";
import clsx from "clsx";
import styles from "./BaseDropDown.module.scss";
export const BaseDropDown = function (props) {
    const containerRef = useRef(null);
    const comboBox = useCombobox({
        items: props.items,
        defaultSelectedItem: props.defaultSelectedItem,
        onSelectedItemChange: props.onSelectedItemChange,
        onInputValueChange: props.onInputValueChange,
        itemToString: props.itemToString,
    });
    const { isOpen, getToggleButtonProps, getMenuProps, reset, toggleMenu, setInputValue, getInputProps, } = comboBox;
    const SelectedItemPreview = props.selectedItem;
    const onDropDownClickHandler = useCallback(() => {
        var _a;
        toggleMenu();
        (_a = props.onDropDownClick) === null || _a === void 0 ? void 0 : _a.call(props, isOpen);
    }, []);
    useEffect(() => {
        reset();
    }, [props.defaultSelectedItem]);
    useEffect(() => {
        var _a, _b;
        if (isOpen) {
            setInputValue("");
            (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input")) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [isOpen]);
    const showInput = !props.disableSelectBySearch && isOpen;
    return (React.createElement(BaseTextFieldFrame, { ref: containerRef, className: clsx(styles.Container, props.className) },
        React.createElement(BaseTextFieldset, { isFocus: isOpen, label: props.label, fieldWrapperClassName: clsx(styles.FieldWrapper, props.fieldWrapperClassName), onClick: onDropDownClickHandler },
            React.createElement("div", Object.assign({ className: clsx(styles.Content, props.contentClassName), onClick: (e) => {
                    e.stopPropagation();
                    comboBox.openMenu();
                } }, comboBox, { style: props.contentStyle }),
                React.createElement("input", Object.assign({ className: clsx(styles.Input, {
                        [styles.IsHidden]: !showInput,
                    }) }, getInputProps(), { placeholder: props.placeholderMessage, alt: props.placeholderMessage })),
                !showInput && (React.createElement(SelectedItemPreview, Object.assign({}, comboBox, { selected: isOpen, loading: props.loading, placeholderMessage: props.placeholderMessage }))),
                React.createElement("div", Object.assign({ className: clsx(styles.DropdownIconWrapper) }, getToggleButtonProps()),
                    React.createElement(ArrowDown2, Object.assign({ size: 24, color: getColorByName(DarkNeutralsColorNames.color_neutrals_n_300), "data-testid": "dropdown-toggle", className: clsx(styles.ToggleButton, {
                            [styles.OpenButton]: isOpen,
                        }) }, getToggleButtonProps()))))),
        React.createElement("div", Object.assign({}, getMenuProps()), isOpen && props.children(Object.assign({}, comboBox)))));
};
//# sourceMappingURL=BaseDropDown.js.map